module.exports = __webpack_public_path__ + "static/6.220f05e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MasterTheses/6.png
// module id = 828
// module chunks = 39236203315009 172526442442348